import { ExperimentSegment, HeroBannerWide } from '@ratehub/web-components';
import { fetchExperimentSegment } from '@ratehub/base-ui';

/**
 * If there's a HeroBannerWide on a page we hide the background circle. If
 * there's an experiment with a HeroBannerWide in a segment, it is ambiguous
 * whether or not that segment is being rendered at the time. Therefore we need
 * to check if there's an experiment with HeroBannerWide, then what segment is
 * being displayed to the user
 */
function shouldHideBackgroundCircle(blocks) {
    let shouldHideBackgroundCircle = false;

    const blocksWithExperiments = getExperimentBlocks(blocks);
    const experimentsWithHeroBannerWide = blocksWithExperiments
        ? blocksWithExperiments.filter(hasHeroBannerWideInExperiment)
        : [];

    experimentsWithHeroBannerWide?.map(experiment => {
        fetchExperimentSegment(experiment.attrs.slug).then(assignedSegment => {
            if (experiment.attrs.segment === assignedSegment && hasHeroBannerWideInExperiment(experiment)) {
                shouldHideBackgroundCircle = true;
            }
        });
    });

    return shouldHideBackgroundCircle;
}

function getExperimentBlocks(blocks) {
    return blocks.filter(block => block.blockName === ExperimentSegment.blockKey);
}

function hasHeroBannerWideInExperiment(experiment) {
    return experiment.innerBlocks.some(block => block.blockName === HeroBannerWide.blockKey);
}

export default shouldHideBackgroundCircle;
